import axios from './axios';

/**
 * Get current user permissions
 */
export const getUserPermissions = async () => {
  try {
    const response = await axios.get('/user-profile/');
    return response.data.permissions || {};
  } catch (error) {
    console.error('Error fetching user permissions:', error);
    return {
      can_view: false,
      can_upload: false,
      can_create: false,
      can_edit: false,
      can_delete: false,
      groups: [],
      is_admin: false,
      is_editor: false,
      is_visualizacion: false,
    };
  }
};

/**
 * Check if user has specific permission
 */
export const hasPermission = (permissions, permission) => {
  if (!permissions) return false;
  return permissions[permission] === true;
};

/**
 * Check if user is in specific group
 */
export const isInGroup = (permissions, groupName) => {
  if (!permissions || !permissions.groups) return false;
  return permissions.groups.includes(groupName);
};

/**
 * Get user role display name
 */
export const getUserRole = (permissions) => {
  if (!permissions) return 'No Role';
  if (permissions.is_admin) return 'Admin';
  if (permissions.is_editor) return 'Editor';
  if (permissions.is_visualizacion) return 'Visualización';
  return 'User';
};
